import Vue from 'vue'
import App from './App'

// 引入common
import common from './api/common.js'
Vue.use(common)

//引入vuex
import store from './store'

//引入路由器
import router from './router/index'

//引入animate.css
import animate from 'animate.css'
Vue.use(animate)

// 注册全局组件,延迟加载组件
import plLazy from "./components/lazy/lazy"
Vue.component('lazy', plLazy);

// 动态修改当前页面的标题
Vue.use(require('vue-wechat-title'));
// 动态改变meta中的值
import Meta from 'vue-meta'
Vue.use(Meta)

// import MeataInfo from 'vue-meta-info'
// Vue.use(MeataInfo)

// 引入'weixin-js-sdk'
import wx from 'weixin-js-sdk'
Vue.use(wx)

import vueSwiper from 'vue-awesome-swiper'
/* 样式的话，我这里有用到分页器，就在全局中引入了样式 */
import 'swiper/dist/css/swiper.css'
Vue.use(vueSwiper);

//引入lay-ui
import layer from 'vue-layer'
Vue.use(layer)


// 移动端Vue.js图片预览插件
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
var options = {
  fullscreenEl: false, //控制是否显示右上角全屏按钮
  closeEl: false, //控制是否显示右上角关闭按钮
  tapToClose: true, //点击滑动区域应关闭图库
  shareEl: false, //控制是否显示分享按钮
  zoomEl: false, //控制是否显示放大缩小按钮
  counterEl: true, //控制是否显示左上角图片数量按钮
  arrowEl: true,  //控制如图的左右箭头（pc浏览器模拟手机时）
  tapToToggleControls: true, //点击应切换控件的可见性
  clickToCloseNonZoomable: true //点击图片应关闭图库，仅当图像小于视口的大小时
};
Vue.use(preview,options)


// 路由变化跳转页面回到顶部
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

// 引入vue cookie
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import Axios from "axios";
Vue.prototype.$axios = Axios

// 微信分享
import wxapi from '../static/js/wxapi.js'
Vue.use(wxapi)

// 一键复制
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

// vant 按需引入
import { NavBar, Tab, Tabs, Search } from 'vant';
Vue.use(NavBar).use(Tab).use(Tabs).use(Search);

// 懒加载
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

new Vue({
  el:"#app",
  //引入路由器
  router,
  //引入vuex
  store,
//  将App.vue渲染出来
  render:h=>h(App)
});



// WEBPACK FOOTER //
// ./src/main.js